module.exports = __webpack_public_path__ + "static/media/de.bcd6a97e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/de.png
// module id = 316
// module chunks = 0